/* eslint-disable no-useless-constructor */
import api from './interApi'
// import qs from 'qs'
// import GLOBAL from '../../static/global'
import config from './config'

function _apiFn (params, baseUrl) { // 该方法对外不可见
  // params.uid = GLOBAL.uid
  // params.nid = GLOBAL.nid
  // params.batch_id = GLOBAL.batch_id
  if (baseUrl === 'passport') {
    api.creatAxios1.defaults.baseURL = config.SERVER_URL2 // 改变 axios 实例的 baseURL
  } else if (baseUrl === 'trade') {
    api.creatAxios1.defaults.baseURL = config.SERVER_URL3
  } else if (baseUrl === 'kapi') {
    api.creatAxios1.defaults.baseURL = config.SERVER_URL4
  } else {
    api.creatAxios1.defaults.baseURL = config.SERVER_URL1
  }
}
class axiosApi {
  constructor () {

  }

  sendGet (url, params = {}, baseUrl) { // get 请求
    if (Object.prototype.toString.call(params) === '[object Object]') {
      const token = window.location.href.split('token=')[1]
      _apiFn(params, baseUrl)
      if (token === 'MDgS2zAqpZ775PerBQv30fXXo8dJiVfG') {
        params.dzhtoken = token
        // if (window.location.href.indexOf('uid=') > -1) {
        //   params.uid = window.location.href.split('uid=')[1].split('&')[0]
        // }
        // if (window.location.href.indexOf('nid=') > -1) {
        //   params.nid = window.location.href.split('nid=')[1].split('&')[0]
        // }
        // if (window.location.href.indexOf('batch_id=') > -1) {
        //   params.batch_id = window.location.href.split('batch_id=')[1].split('&')[0]
        // }
      }
      return api.creatAxios1.get(url, { params: params })
    } else {
      const error = new Error('参数错误！')
      try {
        throw error
      } catch (e) {
        // console.log(e)
      }
    }
  }

  sendPost (url, params = {}, baseUrl) { // post 请求
    if (Object.prototype.toString.call(params) === '[object Object]') {
      _apiFn(params, baseUrl)
      return api.creatAxios1.post(url, params)
    } else {
      const error = new Error('参数错误！')
      try {
        throw error
      } catch (e) {
        // console.log(e)
      }
    }
  }

  /**
   * 并发请求，同时发送多个请求，使用栗子：src/views/infoEntry/dragCard/dragCardService.js
   * 顺序和请求发送的顺序相同
   * @param {arr: [请求1,请求2...]}
   */

  sendAll (arr) { // 并发请求
    return new Promise((resolve, reject) => {
      api.sendAll(arr).then(res => {
        return resolve(res)
      })
    })
  }
}

export default axiosApi



// WEBPACK FOOTER //
// ./src/services/extendsApi.js